import { render, staticRenderFns } from "./DetailPc.vue?vue&type=template&id=9bfb7fcc&"
import script from "./DetailPc.vue?vue&type=script&lang=js&"
export * from "./DetailPc.vue?vue&type=script&lang=js&"
import style0 from "./DetailPc.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports